/**
 * Definition of our Pod (teams) at Faire.
 * Deprecated Pods should be unused in code, i.e no code should be owned by a deprecated pod. Please make sure
 * all product areas are re-assigned to a new pod before deprecating an old pod.
 * For details on (excludeJira) please see the "extend google.protobuf.EnumValueOptions" block above.
 * All deprecated pods should have (excludeJira) = true, do not add new usages of (excludeJira) = true without also
 * deprecating the pod as well.
 * The following pods are annotated with metadata describing the owning pillar, manager, the pod's name in jira (if it
 * doesn't follow convention), and the pod's slack channel (if it doesn't follow convention). For more details on the
 * options, please see the "extend google.protobuf.EnumValueOptions" block above.
 * All active pods are required to belong to one oncall rotation or they cannot submit code to production.
 * All new pods should have a pillar and a manager defined and should ideally not require a name or slack channel
 * override.
 */
export enum FairePod {
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_UNKNOWN = 'FAIRE_POD_UNKNOWN',
  /**
   * @protobufOption (managerEmail) = "jevin@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_ANTI_ABUSE
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   * @protobufOption (slackChannelOverride) = "anti-abuse-alerts"
   */
  FAIRE_POD_ANTI_ABUSE = 'FAIRE_POD_ANTI_ABUSE',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_APPAREL = 'FAIRE_POD_APPAREL',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_APPAREL_BRAND = 'FAIRE_POD_APPAREL_BRAND',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_APPAREL_EVENTS = 'FAIRE_POD_APPAREL_EVENTS',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_APPAREL_PREORDER = 'FAIRE_POD_APPAREL_PREORDER',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_APPAREL_RETAILER = 'FAIRE_POD_APPAREL_RETAILER',
  /**
   * @protobufOption (managerEmail) = "preshoth.paramalingam@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_BRAND
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   * @protobufOption (slackChannelOverride) = "pod-brand-acquisition-alerts"
   */
  FAIRE_POD_BRAND_ACQUISITION = 'FAIRE_POD_BRAND_ACQUISITION',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_BRAND_GROWTH = 'FAIRE_POD_BRAND_GROWTH',
  /**
   * Use FAIRE_POD_MARKETPLACE_QUALITY
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_BRAND_MARKETPLACE_QUALITY = 'FAIRE_POD_BRAND_MARKETPLACE_QUALITY',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_BRAND_ONBOARDING = 'FAIRE_POD_BRAND_ONBOARDING',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_BRAND_ORDER_MANAGEMENT = 'FAIRE_POD_BRAND_ORDER_MANAGEMENT',
  /**
   * Pod is now called POD_FAIRE_DIRECT_REWARDS
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_BRAND_FAIRE_DIRECT = 'FAIRE_POD_BRAND_FAIRE_DIRECT',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_CATEGORY_INCUBATION = 'FAIRE_POD_CATEGORY_INCUBATION',
  /**
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_DATA
   * @protobufOption (slackChannelOverride) = "data-alerts"
   */
  FAIRE_POD_DATA = 'FAIRE_POD_DATA',
  /**
   * @protobufOption (managerEmail) = "tom.ma@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   */
  FAIRE_POD_DISCOVERY_AI = 'FAIRE_POD_DISCOVERY_AI',
  /**
   * @protobufOption (managerEmail) = "samir.durrani@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   */
  FAIRE_POD_DISCOVERY_AE = 'FAIRE_POD_DISCOVERY_AE',
  /**
   * @protobufOption (managerEmail) = "elijah.flesher@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "disco-logging-jira"
   */
  FAIRE_POD_DISCOVERY_LOGGING = 'FAIRE_POD_DISCOVERY_LOGGING',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "dale.hamill@faire.com"
   * @protobufOption (pillar) = FAIRE_PILLAR_PLATFORM
   */
  FAIRE_POD_FAIRE_FOUNDATIONS = 'FAIRE_POD_FAIRE_FOUNDATIONS',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_INTEGRATIONS = 'FAIRE_POD_INTEGRATIONS',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_PLATFORM
   */
  FAIRE_POD_INTERNAL_TOOLS = 'FAIRE_POD_INTERNAL_TOOLS',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_INTERNATIONAL = 'FAIRE_POD_INTERNATIONAL',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_INTERNATIONAL_BRAND_GROWTH = 'FAIRE_POD_INTERNATIONAL_BRAND_GROWTH',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "gray@faire.com"
   * @protobufOption (pillar) = FAIRE_PILLAR_INTERNATIONAL
   */
  FAIRE_POD_INTERNATIONAL_BRAND = 'FAIRE_POD_INTERNATIONAL_BRAND',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_INTERNATIONAL_LAUNCH = 'FAIRE_POD_INTERNATIONAL_LAUNCH',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_INTERNATIONAL
   */
  FAIRE_POD_INTERNATIONAL_PLATFORM = 'FAIRE_POD_INTERNATIONAL_PLATFORM',
  /**
   * This pod has been replaced with FAIRE_POD_RETAILER_PRICING
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "julian.konomi@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_ORDER_INCENTIVES
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER
   */
  FAIRE_POD_MARKETS = 'FAIRE_POD_MARKETS',
  /**
   * This pod has been replaced with FAIRE_POD_SHIPPING
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "alexandre.bisson@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_TOOLS_AND_PROGRAMS
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_TOOLS_AND_PROGRAMS
   * @protobufOption (slackChannelOverride) = "pod-retailer-pricing-alerts"
   */
  FAIRE_POD_RETAILER_PRICING = 'FAIRE_POD_RETAILER_PRICING',
  /**
   * @protobufOption (managerEmail) = "alexandre.bisson@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_VALUE
   * @protobufOption (pillar) = FAIRE_PILLAR_VALUE
   */
  FAIRE_POD_SHIPPING = 'FAIRE_POD_SHIPPING',
  /**
   * Merged MLP into AI Platform
   * @protobufOption (managerEmail) = "gaurav.saraf@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_BRAND
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   * @protobufOption (slackChannelOverride) = "pod-marketplace-quality-alerts"
   */
  FAIRE_POD_MARKETPLACE_QUALITY = 'FAIRE_POD_MARKETPLACE_QUALITY',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_MOBILE = 'FAIRE_POD_MOBILE',
  /**
   * @protobufOption (managerEmail) = "raissa.nucci@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   */
  FAIRE_POD_MOBILE_STRIKE = 'FAIRE_POD_MOBILE_STRIKE',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER
   */
  FAIRE_POD_MOBILE_CORE = 'FAIRE_POD_MOBILE_CORE',
  /**
   * @protobufOption (managerEmail) = "ragan.vadlamudi@faire.com"
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   * @protobufOption (slackChannelOverride) = "pod-mobile-platform-notifications"
   */
  FAIRE_POD_MOBILE_PLATFORM = 'FAIRE_POD_MOBILE_PLATFORM',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_MOBILE_EXPANSION = 'FAIRE_POD_MOBILE_EXPANSION',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "ani.borah@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_INTERNATIONAL
   * @protobufOption (pillar) = FAIRE_PILLAR_INTERNATIONAL
   */
  FAIRE_POD_MOBILE_INTERNATIONAL = 'FAIRE_POD_MOBILE_INTERNATIONAL',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_MULTI_SERVICE = 'FAIRE_POD_MULTI_SERVICE',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "ryan@faire.com"
   * @protobufOption (pillar) = FAIRE_PILLAR_PLATFORM
   * @protobufOption (slackChannelOverride) = "pod-platform-updates"
   */
  FAIRE_POD_PLATFORM = 'FAIRE_POD_PLATFORM',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "cheuk-man.kong@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_PLATFORM
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   */
  FAIRE_POD_PLATFORM_CONTROL = 'FAIRE_POD_PLATFORM_CONTROL',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "felix.reyn@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_PLATFORM
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   */
  FAIRE_POD_PLATFORM_SCALE = 'FAIRE_POD_PLATFORM_SCALE',
  /**
   * @protobufOption (managerEmail) = "felix.reyn@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_PLATFORM
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   */
  FAIRE_POD_PLATFORM_RELIABILITY = 'FAIRE_POD_PLATFORM_RELIABILITY',
  /**
   * @protobufOption (managerEmail) = "khaled.said@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_PLATFORM
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   */
  FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS = 'FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS',
  /**
   * This pod has been replaced with FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "felix.reyn@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_PLATFORM
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   */
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCE = 'FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCE',
  /**
   * @protobufOption (managerEmail) = "khaled.said@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_PLATFORM
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   */
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY = 'FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_PLATFORM_TAP = 'FAIRE_POD_PLATFORM_TAP',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "mark.widish@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_BRAND
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_BRAND_INFRASTRUCTURE = 'FAIRE_POD_BRAND_INFRASTRUCTURE',
  /**
   * Duplicate of FAIRE_POD_APPAREL_PREORDER
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_PREORDERS = 'FAIRE_POD_PREORDERS',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (oncall) = FAIRE_ONCALL_BRAND
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_PRICING = 'FAIRE_POD_PRICING',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_BRAND_PRICING = 'FAIRE_POD_BRAND_PRICING',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "bryan.holder@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_PLATFORM
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   */
  FAIRE_POD_QUALITY = 'FAIRE_POD_QUALITY',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_RISK = 'FAIRE_POD_RISK',
  /**
   * @protobufOption (managerEmail) = "bryan.holder@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_SECURITY
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   */
  FAIRE_POD_SECURITY = 'FAIRE_POD_SECURITY',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_RETAILER_LIFECYCLE = 'FAIRE_POD_RETAILER_LIFECYCLE',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_RETAILER_CONFIDENCE = 'FAIRE_POD_RETAILER_CONFIDENCE',
  /**
   * FAIRE_POD_RETAILER_GROWTH was replaced by FAIRE_POD_RETAILER_ACTIVATION
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_GROWTH
   */
  FAIRE_POD_RETAILER_GROWTH = 'FAIRE_POD_RETAILER_GROWTH',
  /**
   * @protobufOption (managerEmail) = "luthfur.chowdhury@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_GROWTH
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_GROWTH
   */
  FAIRE_POD_RETAILER_ACTIVATION = 'FAIRE_POD_RETAILER_ACTIVATION',
  /**
   * @protobufOption (managerEmail) = "luthfur.chowdhury@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_GROWTH
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_GROWTH
   * @protobufOption (slackChannelOverride) = "pod-retailer-onboarding-notifications"
   */
  FAIRE_POD_RETAILER_ONBOARDING = 'FAIRE_POD_RETAILER_ONBOARDING',
  /**
   * Team was broken down into smaller team
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_RETAILER_DISCOVERY = 'FAIRE_POD_RETAILER_DISCOVERY',
  /**
   * @protobufOption (managerEmail) = "howard.pang@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_VALUE
   * @protobufOption (pillar) = FAIRE_PILLAR_VALUE
   * @protobufOption (slackChannelOverride) = "pod-insider-sla"
   */
  FAIRE_POD_INSIDER = 'FAIRE_POD_INSIDER',
  /**
   * @protobufOption (excludeJira) = true
   * @protobufOption (oncall) = FAIRE_ONCALL_UNASSIGNED
   * @protobufOption (pillar) = FAIRE_PILLAR_UNASSIGNED
   */
  FAIRE_POD_UNASSIGNED = 'FAIRE_POD_UNASSIGNED',
  /**
   * @protobufOption (managerEmail) = "mark.widish@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_BRAND
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   * @protobufOption (slackChannelOverride) = "pillar-brand-eng-sla"
   */
  FAIRE_POD_BRAND_UNASSIGNED = 'FAIRE_POD_BRAND_UNASSIGNED',
  /**
   * @protobufOption (managerEmail) = "ragan.vadlamudi@faire.com"
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   */
  FAIRE_POD_WEB_PLATFORM = 'FAIRE_POD_WEB_PLATFORM',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_CLIENT_TOOLS = 'FAIRE_POD_CLIENT_TOOLS',
  /**
   * The team is now called FAIRE_POD_FINANCIAL_PRODUCTS
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_RETAILER_UNDERWRITING = 'FAIRE_POD_RETAILER_UNDERWRITING',
  /**
   * Entire team transitioned to BRAND_ACQUISITION
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_ORDER_WRITING = 'FAIRE_POD_ORDER_WRITING',
  /**
   * Team disbanded after product was localized.
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_LOCALIZATION = 'FAIRE_POD_LOCALIZATION',
  /**
   * Use FAIRE_POD_BRAND_MARKETPLACE_QUALITY
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_BRAND_MARKETPLACE_SUCCESS = 'FAIRE_POD_BRAND_MARKETPLACE_SUCCESS',
  /**
   * FAIRE_POD_STABLE_STAPLES was replaced by FAIRE_POD_RETAILER_REORDER
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_STABLE_STAPLES = 'FAIRE_POD_STABLE_STAPLES',
  /**
   * @protobufOption (managerEmail) = "howard.pang@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_VALUE
   * @protobufOption (pillar) = FAIRE_PILLAR_VALUE
   * @protobufOption (slackChannelOverride) = "pod-financial-products-sla"
   */
  FAIRE_POD_FINANCIAL_PRODUCTS = 'FAIRE_POD_FINANCIAL_PRODUCTS',
  /**
   * Renamed to FAIRE_POD_UPMARKET_GROWTH
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_UPMARKET = 'FAIRE_POD_UPMARKET',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "dmytro.landberg@faire.com"
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER
   * @protobufOption (slackChannelOverride) = "pod-retailer-inspire-notifications"
   */
  FAIRE_POD_RETAILER_INSPIRE = 'FAIRE_POD_RETAILER_INSPIRE',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "eric.hacke@faire.com"
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   */
  FAIRE_POD_RETAILER_SEARCH = 'FAIRE_POD_RETAILER_SEARCH',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_RETAILER_CHECKOUT = 'FAIRE_POD_RETAILER_CHECKOUT',
  /**
   * @protobufOption (managerEmail) = "pavlo.kuzhel@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_GROWTH
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_GROWTH
   * @protobufOption (slackChannelOverride) = "pod-acquisition"
   */
  FAIRE_POD_RETAILER_ACQUISITION = 'FAIRE_POD_RETAILER_ACQUISITION',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_ORDER_INCENTIVES
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER
   */
  FAIRE_POD_RETAILER_EVALUATE = 'FAIRE_POD_RETAILER_EVALUATE',
  /**
   * Pod is deprecated, use FAIRE_POD_FAIRE_DIRECT_GROWTH
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_FAIRE_DIRECT_REWARDS = 'FAIRE_POD_FAIRE_DIRECT_REWARDS',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_FAIRE_DIRECT_CRM = 'FAIRE_POD_FAIRE_DIRECT_CRM',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_FAIRE_DIRECT_PROSPECTING = 'FAIRE_POD_FAIRE_DIRECT_PROSPECTING',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "cedo.segulja@faire.com"
   * @protobufOption (pillar) = FAIRE_PILLAR_EXPANSION
   */
  FAIRE_POD_APPAREL_INTEGRATIONS = 'FAIRE_POD_APPAREL_INTEGRATIONS',
  /**
   * Merged into to FAIRE_POD_BRAND_ONBOARDING
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_BRAND_F30D_LIFECYCLE = 'FAIRE_POD_BRAND_F30D_LIFECYCLE',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "dave.collie@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_INTERNATIONAL
   * @protobufOption (pillar) = FAIRE_PILLAR_INTERNATIONAL
   */
  FAIRE_POD_INTERNATIONAL_TRANSLATION = 'FAIRE_POD_INTERNATIONAL_TRANSLATION',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "ryan.orr@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_INTERNATIONAL
   * @protobufOption (pillar) = FAIRE_PILLAR_INTERNATIONAL
   * @protobufOption (slackChannelOverride) = "pod-invoicing-support-experience"
   */
  FAIRE_POD_INVOICING_AND_SUPPORT_EXPERIENCE = 'FAIRE_POD_INVOICING_AND_SUPPORT_EXPERIENCE',
  /**
   * Replaced by FAIRE_POD_INVOICING_AND_SUPPORT_EXPERIENCE
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_VAT_INTL_CX = 'FAIRE_POD_VAT_INTL_CX',
  /**
   * Replaced by FAIRE_POD_VAT_INTL_CX
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_INTERNATIONAL_CX = 'FAIRE_POD_INTERNATIONAL_CX',
  /**
   * Replaced by FAIRE_POD_SHIPPING_EXPERIENCE
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_XB_SHIPPING = 'FAIRE_POD_XB_SHIPPING',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_SHIPPING_EXPERIENCE = 'FAIRE_POD_SHIPPING_EXPERIENCE',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_RETAILER_INFRASTRUCTURE = 'FAIRE_POD_RETAILER_INFRASTRUCTURE',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "eliot.daigneaultmestre@faire.com"
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   */
  FAIRE_POD_RETAILER_TAXONOMY = 'FAIRE_POD_RETAILER_TAXONOMY',
  /**
   * Totally deprecated, product areas handed off
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "austin.dobrik@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   */
  FAIRE_POD_FOOD_AND_BEVERAGE = 'FAIRE_POD_FOOD_AND_BEVERAGE',
  /**
   * Renamed to FAIRE_POD_UPMARKET_TOOLING
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_UPMARKET_GROWTH = 'FAIRE_POD_UPMARKET_GROWTH',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "howard.pang@faire.com"
   * @protobufOption (pillar) = FAIRE_PILLAR_EXPANSION
   */
  FAIRE_POD_UPMARKET_EXPERIENCE = 'FAIRE_POD_UPMARKET_EXPERIENCE',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "ani.borah@faire.com"
   * @protobufOption (pillar) = FAIRE_PILLAR_INTERNATIONAL
   */
  FAIRE_POD_FREIGHT_MARGIN = 'FAIRE_POD_FREIGHT_MARGIN',
  /**
   * FAIRE_POD_RETAILER_REORDER was replaced by FAIRE_POD_RETAILER_SUCCESS
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_RETAILER_REORDER = 'FAIRE_POD_RETAILER_REORDER',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_BRAND_ENTERPRISE = 'FAIRE_POD_BRAND_ENTERPRISE',
  /**
   * @protobufOption (managerEmail) = "ragan.vadlamudi@faire.com"
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   * @protobufOption (slackChannelOverride) = "pod-slate"
   */
  FAIRE_POD_SLATE_DESIGN_SYSTEM = 'FAIRE_POD_SLATE_DESIGN_SYSTEM',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "eliot.daigneaultmestre@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "pod-discovery-infra-enablement"
   */
  FAIRE_POD_SEARCH_INFRASTRUCTURE = 'FAIRE_POD_SEARCH_INFRASTRUCTURE',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_RETAILER_CART_SERVICE = 'FAIRE_POD_RETAILER_CART_SERVICE',
  /**
   * Renamed to FAIRE_POD_UPMARKET_TOOLING
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "howard.pang@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_ORDER_INCENTIVES
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER
   */
  FAIRE_POD_UPMARKET_TEAM_MANAGEMENT = 'FAIRE_POD_UPMARKET_TEAM_MANAGEMENT',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "mark.fennema@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_TOOLS_AND_PROGRAMS
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_TOOLS_AND_PROGRAMS
   * @protobufOption (slackChannelOverride) = "pod-upmarket-tooling-sla"
   */
  FAIRE_POD_UPMARKET_TOOLING = 'FAIRE_POD_UPMARKET_TOOLING',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_RETENTION_EXPERIENCE = 'FAIRE_POD_RETENTION_EXPERIENCE',
  /**
   * Renamed to FAIRE_POD_RETAILER_TOFU
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_RETAILER_SEO = 'FAIRE_POD_RETAILER_SEO',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_BRAND_SERVICE_STANDARDS = 'FAIRE_POD_BRAND_SERVICE_STANDARDS',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_SUPPLY_INTEGRITY = 'FAIRE_POD_SUPPLY_INTEGRITY',
  /**
   * FAIRE_POD_RETAILER_SUCCESS was replaced by FAIRE_POD_RETAILER_ORDER_PLACEMENT
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "thiago.pilon@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_ORDER_INCENTIVES
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER
   */
  FAIRE_POD_RETAILER_SUCCESS = 'FAIRE_POD_RETAILER_SUCCESS',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_THEMATIC_DISCOVERY = 'FAIRE_POD_THEMATIC_DISCOVERY',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "eliot.daigneaultmestre@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "pod-discovery-infra-enablement"
   */
  FAIRE_POD_TAXONOMY = 'FAIRE_POD_TAXONOMY',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "austin.dobrik@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "pod-evaluate-and-order-notifications"
   */
  FAIRE_POD_SEARCH_EXPERIENCE = 'FAIRE_POD_SEARCH_EXPERIENCE',
  /**
   * @protobufOption (managerEmail) = "dmytro.landberg@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "pod-discovery-inspire-eng"
   */
  FAIRE_POD_INSPIRE = 'FAIRE_POD_INSPIRE',
  /**
   * @protobufOption (managerEmail) = "jason.xu@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "search-algo-alerts"
   */
  FAIRE_POD_SEARCH_RANKING_ALGORITHMS = 'FAIRE_POD_SEARCH_RANKING_ALGORITHMS',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "ani.borah@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "pod-discovery-paid-placement-sla"
   */
  FAIRE_POD_DISCOVERY_PAID_PLACEMENT = 'FAIRE_POD_DISCOVERY_PAID_PLACEMENT',
  /**
   * @protobufOption (managerEmail) = "luthfur.chowdhury@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_GROWTH
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_GROWTH
   * @protobufOption (slackChannelOverride) = "retailer-growth-mobile-sla"
   */
  FAIRE_POD_GROWTH_MOBILE = 'FAIRE_POD_GROWTH_MOBILE',
  /**
   * Renamed to FAIRE_POD_GROWTH_PLATFORM
   * @deprecated
   * @protobufOption (excludeJira) = true
   */
  FAIRE_POD_COMMUNICATIONS_PLATFORM = 'FAIRE_POD_COMMUNICATIONS_PLATFORM',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_GROWTH
   */
  FAIRE_POD_OPEN_WITH_FAIRE = 'FAIRE_POD_OPEN_WITH_FAIRE',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_COMMISSION = 'FAIRE_POD_COMMISSION',
  /**
   * @protobufOption (managerEmail) = "riley.davidson@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_GROWTH
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_GROWTH
   * @protobufOption (slackChannelOverride) = "pod-faire-direct-growth-notifications"
   */
  FAIRE_POD_FAIRE_DIRECT_GROWTH = 'FAIRE_POD_FAIRE_DIRECT_GROWTH',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_SHOPIFY = 'FAIRE_POD_SHOPIFY',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "howard.pang@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_INTEGRATIONS
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER
   * @protobufOption (slackChannelOverride) = "pod-retailer-pos-integrations-sla"
   */
  FAIRE_POD_RETAILER_POS_INTEGRATIONS = 'FAIRE_POD_RETAILER_POS_INTEGRATIONS',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "mario.hebert@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_GROWTH
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_GROWTH
   */
  FAIRE_POD_RETAILER_TOFU = 'FAIRE_POD_RETAILER_TOFU',
  /**
   * AI Foundations merged into AI Platform
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "raissa.nucci@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "pod-browse-sla"
   */
  FAIRE_POD_BROWSE = 'FAIRE_POD_BROWSE',
  /**
   * @protobufOption (managerEmail) = "georgii@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_ANTI_ABUSE
   * @protobufOption (pillar) = FAIRE_PILLAR_VALUE
   * @protobufOption (slackChannelOverride) = "data-team-financial-products"
   */
  FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS = 'FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "dmytro.landberg@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "pod-discovery-recommendations"
   */
  FAIRE_POD_RECOMMENDATIONS = 'FAIRE_POD_RECOMMENDATIONS',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "austin.dobrik@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   */
  FAIRE_POD_SEARCH_EXPERIENCE_ACCELERATOR = 'FAIRE_POD_SEARCH_EXPERIENCE_ACCELERATOR',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_INTERNATIONAL_FOUNDATIONS = 'FAIRE_POD_INTERNATIONAL_FOUNDATIONS',
  /**
   * replaced by FAIRE_POD_OPS_ENABLEMENT
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "matthew.d-cruz@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_TOOLS_AND_PROGRAMS
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_TOOLS_AND_PROGRAMS
   */
  FAIRE_POD_SUPPORT_EXPERIENCE = 'FAIRE_POD_SUPPORT_EXPERIENCE',
  /**
   * Merged into FAIRE_POD_BRAND_CATALOG_COMPLETENESS_AND_BRAND_PROGRAMS
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "donald.ho@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_BRAND
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS = 'FAIRE_POD_BRAND_CATALOG_COMPLETENESS',
  /**
   * @protobufOption (managerEmail) = "cheryl.lau@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_GROWTH
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_GROWTH
   */
  FAIRE_POD_GROWTH_PLATFORM = 'FAIRE_POD_GROWTH_PLATFORM',
  /**
   * @protobufOption (managerEmail) = "neel.hajare@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_VALUE
   * @protobufOption (pillar) = FAIRE_PILLAR_VALUE
   * @protobufOption (slackChannelOverride) = "pod-retailer-order-placement-sla"
   */
  FAIRE_POD_RETAILER_ORDER_PLACEMENT = 'FAIRE_POD_RETAILER_ORDER_PLACEMENT',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (jiraNameOverride) = "Retailer POS Integrations"
   * @protobufOption (managerEmail) = "matthew.d-cruz@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_TOOLS_AND_PROGRAMS
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_TOOLS_AND_PROGRAMS
   * @protobufOption (slackChannelOverride) = "pod-retailer-order-management-sla"
   */
  FAIRE_POD_RETAILER_ORDER_MANAGEMENT = 'FAIRE_POD_RETAILER_ORDER_MANAGEMENT',
  /**
   * @protobufOption (jiraNameOverride) = "BOM"
   * @protobufOption (managerEmail) = "preshoth.paramalingam@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_BRAND
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   * @protobufOption (slackChannelOverride) = "pod-bom"
   */
  FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT = 'FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_BRAND_PRICING_AND_REORDERS = 'FAIRE_POD_BRAND_PRICING_AND_REORDERS',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS_AND_BRAND_PROGRAMS = 'FAIRE_POD_BRAND_CATALOG_COMPLETENESS_AND_BRAND_PROGRAMS',
  /**
   * @protobufOption (managerEmail) = "tim.yangtuo@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_BRAND
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   * @protobufOption (slackChannelOverride) = "pod-listing-quality-product-attributes"
   */
  FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES = 'FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES',
  /**
   * @protobufOption (managerEmail) = "xiannian.fan@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   */
  FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT = 'FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT',
  /**
   * @protobufOption (managerEmail) = "michael.tompkins@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DATA_SCIENCE_ML_PLATFORM
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   */
  FAIRE_POD_EXPERIMENT_PLATFORM = 'FAIRE_POD_EXPERIMENT_PLATFORM',
  /**
   * @protobufOption (managerEmail) = "michael.tompkins@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DATA_SCIENCE_ML_PLATFORM
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   */
  FAIRE_POD_KNOWLEDGE_GRAPH = 'FAIRE_POD_KNOWLEDGE_GRAPH',
  /**
   * @protobufOption (jiraNameOverride) = "Platform Productivity"
   * @protobufOption (managerEmail) = "cheuk-man.kong@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_PLATFORM
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   * @protobufOption (slackChannelOverride) = "pod-platform-productivity"
   */
  FAIRE_POD_PLATFORM_PRODUCTIVITY = 'FAIRE_POD_PLATFORM_PRODUCTIVITY',
  /**
   * @protobufOption (managerEmail) = "dmytro.landberg@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   */
  FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM = 'FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM',
  /**
   * @protobufOption (managerEmail) = "yuanchi.ning@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "personalization-team"
   */
  FAIRE_POD_PERSONALIZATION = 'FAIRE_POD_PERSONALIZATION',
  /**
   * @protobufOption (managerEmail) = "ryan.closner@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_BRAND
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_BRAND_CATALOG_GROWTH = 'FAIRE_POD_BRAND_CATALOG_GROWTH',
  /**
   * @protobufOption (managerEmail) = "jason.xu@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "search-algo-alerts"
   */
  FAIRE_POD_SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL = 'FAIRE_POD_SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL',
  /**
   * @protobufOption (managerEmail) = "michael.tompkins@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DATA_SCIENCE_ML_PLATFORM
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   */
  FAIRE_POD_CORE_DATA_INFRA = 'FAIRE_POD_CORE_DATA_INFRA',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "ani.borah@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "pod-discovery-paid-placement-sla"
   */
  FAIRE_POD_PP_ADS_MANAGER = 'FAIRE_POD_PP_ADS_MANAGER',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "ani.borah@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "pod-discovery-paid-placement-sla"
   */
  FAIRE_POD_PP_ADS_DELIVERY = 'FAIRE_POD_PP_ADS_DELIVERY',
  /**
   * @protobufOption (managerEmail) = "robby.zeller@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_GROWTH
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_GROWTH
   */
  FAIRE_POD_RETAILER_GROWTH_DATA_SCIENCE = 'FAIRE_POD_RETAILER_GROWTH_DATA_SCIENCE',
  /**
   * @protobufOption (managerEmail) = "robby.zeller@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_BRAND
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_BRAND_DATA_SCIENCE = 'FAIRE_POD_BRAND_DATA_SCIENCE',
  /**
   * @protobufOption (managerEmail) = "jevin@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_VALUE
   * @protobufOption (pillar) = FAIRE_PILLAR_VALUE
   */
  FAIRE_POD_DATA_TEAM_INSIDER_AND_SHIPPING_COSTS = 'FAIRE_POD_DATA_TEAM_INSIDER_AND_SHIPPING_COSTS',
  /**
   * @protobufOption (managerEmail) = "neel.hajare@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_VALUE
   * @protobufOption (pillar) = FAIRE_PILLAR_VALUE
   */
  FAIRE_POD_VALUE_MOBILE = 'FAIRE_POD_VALUE_MOBILE',
  /**
   * @protobufOption (managerEmail) = "namit.katariya@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DATA_SCIENCE_ML_PLATFORM
   * @protobufOption (pillar) = FAIRE_PILLAR_EPDD_FOUNDATIONS
   * @protobufOption (slackChannelOverride) = "data-alerts-ml-platform"
   */
  FAIRE_POD_AI_PLATFORM = 'FAIRE_POD_AI_PLATFORM',
  /**
   * @protobufOption (managerEmail) = "matthew.d-cruz@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_VALUE
   * @protobufOption (pillar) = FAIRE_PILLAR_VALUE
   */
  FAIRE_POD_OPS_ENABLEMENT = 'FAIRE_POD_OPS_ENABLEMENT',
  /**
   * @protobufOption (jiraNameOverride) = "Evaluate & Order"
   * @protobufOption (managerEmail) = "austin.dobrik@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "pod-evaluate-and-order-notifications"
   */
  FAIRE_POD_EVALUATE = 'FAIRE_POD_EVALUATE',
  /**
   * @deprecated
   * @protobufOption (excludeJira) = true
   * @protobufOption (managerEmail) = "ani.borah@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "pod-discovery-paid-placement-sla"
   */
  FAIRE_POD_ADS = 'FAIRE_POD_ADS',
  /**
   * @protobufOption (managerEmail) = "ani.borah@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "pod-discovery-paid-placement-sla"
   */
  FAIRE_POD_ADS_DELIVERY = 'FAIRE_POD_ADS_DELIVERY',
  /**
   * @protobufOption (managerEmail) = "ani.borah@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "pod-discovery-paid-placement-sla"
   */
  FAIRE_POD_ADS_MANAGER = 'FAIRE_POD_ADS_MANAGER',
  /**
   * @protobufOption (managerEmail) = "mark.widish@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_BRAND
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_BRAND_PLATFORM = 'FAIRE_POD_BRAND_PLATFORM',
  /**
   * @protobufOption (managerEmail) = "ryan.closner@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_BRAND
   * @protobufOption (pillar) = FAIRE_PILLAR_BRAND
   */
  FAIRE_POD_BRAND_PLATFORM_COMPLIANCE = 'FAIRE_POD_BRAND_PLATFORM_COMPLIANCE',
  /**
   * @protobufOption (managerEmail) = "neel.hajare@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_VALUE
   * @protobufOption (pillar) = FAIRE_PILLAR_VALUE
   * @protobufOption (slackChannelOverride) = "service-orders"
   */
  FAIRE_POD_ORDERS_MIGRATION = 'FAIRE_POD_ORDERS_MIGRATION',
  /**
   * @protobufOption (managerEmail) = "howard.pang@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_VALUE
   * @protobufOption (pillar) = FAIRE_PILLAR_VALUE
   */
  FAIRE_POD_FAIRE_PAY = 'FAIRE_POD_FAIRE_PAY',
  /**
   * @protobufOption (managerEmail) = "matthew.d-cruz@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_VALUE
   * @protobufOption (pillar) = FAIRE_PILLAR_VALUE
   * @protobufOption (slackChannelOverride) = "pod-one-stop-shop-sla"
   */
  FAIRE_POD_ONE_STOP_SHOP = 'FAIRE_POD_ONE_STOP_SHOP',
  /**
   * @protobufOption (managerEmail) = "mark.fennema@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_VALUE
   * @protobufOption (pillar) = FAIRE_PILLAR_VALUE
   */
  FAIRE_POD_MARKETS_COORDINATION = 'FAIRE_POD_MARKETS_COORDINATION',
  /**
   * @protobufOption (managerEmail) = "alexandre.bisson@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_VALUE
   * @protobufOption (pillar) = FAIRE_PILLAR_VALUE
   * @protobufOption (slackChannelOverride) = "pod-fbf-sla"
   */
  FAIRE_POD_FULFILLED_BY_FAIRE = 'FAIRE_POD_FULFILLED_BY_FAIRE',
  /**
   * @protobufOption (managerEmail) = "raissa.nucci@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_DISCOVERY
   * @protobufOption (pillar) = FAIRE_PILLAR_DISCOVERY
   * @protobufOption (slackChannelOverride) = "pod-search-ux-sla"
   */
  FAIRE_POD_SEARCH_UX = 'FAIRE_POD_SEARCH_UX',
  /**
   * @protobufOption (managerEmail) = "riley.davidson@faire.com"
   * @protobufOption (oncall) = FAIRE_ONCALL_RETAILER_GROWTH
   * @protobufOption (pillar) = FAIRE_PILLAR_RETAILER_GROWTH
   * @protobufOption (slackChannelOverride) = "pod-relationship-growth-notifications"
   */
  FAIRE_POD_RELATIONSHIP_GROWTH = 'FAIRE_POD_RELATIONSHIP_GROWTH',
}
